import React from "react";
import QueriesBoard from "../../components/QueriesBoard";

export default function HRQueries() {
  return (
    <div data-testid="hr-queries-page">
      <QueriesBoard showBranchFilter />
    </div>
  );
}
